define('payment/methods/providerAmountWithdraw',['jquery'], function ($) {

    'use strict';

    function init(pageGsonParameter){
        $('.max_wd_amount').text(pageGsonParameter.max_wd_amount);
        $('.min_wd_amount').text(pageGsonParameter.min_wd_amount);
        $('.fee_amount').text(pageGsonParameter.fee_amount);
    }

    var providerAmountWithdraw = {};
    providerAmountWithdraw.init = init;
    return providerAmountWithdraw;
});
